var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0","maskType":"alpha","maskUnits":"userSpaceOnUse","x":"4","y":"1","width":"8","height":"14","key":0},React.createElement("rect",{"x":"4","y":"1","width":"8","height":"14","fill":"white"})),React.createElement("g",{"mask":"url(#mask0)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.09322 15V8.7H11.1334L11.4667 5.9H9.09322V4.5364C9.09322 3.8154 9.11287 3.1 10.1875 3.1H11.276V1.098C11.276 1.0679 10.3411 1 9.39518 1C7.41974 1 6.18281 2.1599 6.18281 4.29V5.9H4V8.7H6.18281V15H9.09322Z","fill":"#D7D7D7"}))]);
}

Facebook.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
